import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';

function UploadMaterialScreen() {
    const navigate = useNavigate();
    const [formFields, setFormFields] = useState({'item_name': '', 'item_type': '', 'amount': '', 'copies_available': '', 'language': '', 'discount': '', 'author': '', 'description': ''});
    const { setTostMessage } = useContext(TostMessageContext);
    const [cookies, setCookie, removeCookie] = useCookies();
    const {setUserProfile, userProfile, logOutFunction, reloadUser} = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState(null);

    const uploadHandler = (event) => {
        const newFiles = event.target.files;
        if (!newFiles) return;
        setFiles(newFiles[0]);
        console.log(newFiles[0])
    };

    useEffect(() => {
        console.log(userProfile);
    }, [])

    const submit = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("item_name", formFields.item_name);
        formData.append("item_type", formFields.item_type);
        formData.append("amount", formFields.amount);
        formData.append("copies_available", formFields.copies_available);
        formData.append("language", formFields.language);
        formData.append("discount", formFields.discount);
        formData.append("author", formFields.author);
        formData.append("cover_photo", files);
        formData.append("description", formFields.description);

        try {
            const response = await axios.post(base_url + '/shop/upload-material.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoading(false);
                setTostMessage({
                    messageType: "success",
                    message: response.data.response,
                });
                setFormFields({'item_name': '', 'item_type': '', 'amount': '', 'copies_available': '', 'language': '', 'discount': '', 'author': '', 'description': ''});
                navigate("/materials-inventory");
            } else {
                setLoading(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='flex flex-row justify-between'>
                    <div className="w-full px-10 py-[4rem] bg-[#FAFAFA] rounded-lg">
                        <h1 className="text-2xl font-bold text-gray-800 mb-6">Upload Shop Material</h1>
                        <div className="flex inline-flex flex-wrap w-full justify-between">
                            <div className='w-full md:w-[60%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Cover Image <span className="text-red-500">*</span>
                                </label>
                                <div className="FileUpload">
                                    <div className="file-card hover:scale-95 transition-all">
                                        <div className="file-inputs">
                                            <input type="file" multiple accept={"image/*"} onChange={(e) => uploadHandler(e)} />
                                            <button className="bg-secondary rounded-full">Select cover image</button>
                                        </div>
                                        <p className="font-semibold text-yellow">{files && files?.name + ' selected'}</p>
                                        <p className="main">Supported files</p>
                                        <p className="info">{'PNG, JPG'}</p>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Item Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter item name"
                                    onChange={(e) => setFormFields({...formFields, item_name: e.target.value})}
                                />
                            </div>

                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                   Author <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter author name"
                                    onChange={(e) => setFormFields({...formFields, author: e.target.value})}
                                />
                            </div>

                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Language <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, language: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    {userProfile?.misc?.language?.map((item, index) => 
                                        <option key={index} value={item.language}>{item.language}</option>
                                    )}
                                </select>
                            </div>

                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Select Type <span className="text-red-500">*</span>
                                </label>
                                <select onChange={(e) => setFormFields({...formFields, item_type: e.target.value})} className="border border-gray-300 h-[61px] px-3 py-2 rounded-md text-sm text-gray-700 w-full focus:outline-none focus:ring-2 focus:ring-yellow">
                                    <option value="">Select option</option>
                                    <option value="E-BOOK">E-Book</option>
                                    <option value="PHYSICAL COPY">Physical Copy</option>
                                </select>
                            </div>
                            
                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amount Per Copy <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter amount (USD)"
                                    onChange={(e) => setFormFields({...formFields, amount: e.target.value})}
                                />
                            </div>

                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Copies Available 
                                </label>
                                <input
                                    type="number"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Leave empty if unlimited"
                                    onChange={(e) => setFormFields({...formFields, copies_available: e.target.value})}
                                />
                            </div>
                            
                            <div className='w-full md:w-[48%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                   Discount 
                                </label>
                                <input
                                    type="text"
                                    className="h-[61px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter discount amount (USD)"
                                    onChange={(e) => setFormFields({...formFields, discount: e.target.value})}
                                />
                            </div>

                            <div className='w-full md:w-[70%] my-5'>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Description 
                                </label>
                                <textarea
                                    className="min-h-[100px] w-full px-3 py-2 border border-gray-300 rounded-[10px] focus:outline-none focus:ring-2 focus:ring-yellow"
                                    placeholder="Enter some information about this item"
                                    onChange={(e) => setFormFields({...formFields, description: e.target.value})}
                                ></textarea>
                            </div>
                            
                            <div className='w-full mt-3 flex justify-end'>
                                <ButtonSmall onPress={() => submit()} label={'Upload'} loading={loading} />
                            </div>
                        </div>
                        </div>
                </div>
            </main>
        </div>
    </div>
  );
}

export default UploadMaterialScreen;
